import PropTypes from 'prop-types';
import React from 'react';
import { ListGroup } from 'react-bootstrap';
import NavCollapse from '../NavCollapse';
import NavItem from '../NavItem';

const NavGroup = ({ layout, group }) => {
  let navItems = '';

  if (group.children) {
    const userInfo = JSON.parse(localStorage.getItem('userInfo') || '{}');
    const isSuperAdmin = userInfo.role_name === 'SuperAdmin';
    const isDelegate =
      userInfo.role_id === 4 || userInfo.role_id === '4' || userInfo.role_name === 'DeletegateAdmin' || userInfo.role === 'Delegate Admin';

    let filteredChildren = group.children;

    if (!isSuperAdmin) {
      filteredChildren = filteredChildren.filter((child) => child.id !== 'clientManagement' && child.id !== 'auditLog');
    }

    if (isDelegate) {
      const perms = userInfo.permissions || userInfo;
      filteredChildren = group.children.filter((child) => {
        // Manage Delegate Role Tab maps to manage_custom_role
        if (child.id === 'manageDelegateRole') {
          return perms.manage_custom_role !== null && perms.manage_custom_role !== undefined;
        }

        // Check module permissions on userInfo (value 0 or 1 is allowed, null/undefined is blocked)
        if (child.id === 'dashboard') {
          return perms.dashboard !== null && perms.dashboard !== undefined;
        }
        if (child.id === 'manageAuditors') {
          return perms.manage_auditor !== null && perms.manage_auditor !== undefined;
        }
        if (child.id === 'ibpReference') {
          return perms.ibp_ref !== null && perms.ibp_ref !== undefined;
        }
        if (child.id === 'manageTemplates') {
          return perms.manage_template !== null && perms.manage_template !== undefined;
        }
        if (child.id === 'myChapters') {
          return perms.manage_chapter !== null && perms.manage_chapter !== undefined;
        }
        if (child.id === 'myAudit') {
          return perms.my_audit !== null && perms.my_audit !== undefined;
        }
        if (child.id === 'manageSites') {
          return (
            (perms.my_audit !== null && perms.my_audit !== undefined) ||
            (perms.auditor_audit !== null && perms.auditor_audit !== undefined)
          );
        }
        if (child.id === 'auditReports') {
          return perms.audit_report !== null && perms.audit_report !== undefined;
        }
        if (child.id === 'subscription') {
          return perms.manage_subscription !== null && perms.manage_subscription !== undefined;
        }
        if (child.id === 'supportTickets') {
          return perms.manage_support_ticket !== null && perms.manage_support_ticket !== undefined;
        }

        // Client Management & Audit Log are Super Admin only — always hide for delegates
        if (child.id === 'clientManagement' || child.id === 'auditLog') {
          return false;
        }

        if (child.id === 'aiAssistant') {
          return true;
        }

        // Settings or Logout are always allowed
        return true;
      });
    }

    navItems = filteredChildren.map((item) => {
      switch (item.type) {
        case 'collapse':
          return <NavCollapse key={item.id} collapse={item} type="main" />;
        case 'item':
          return <NavItem layout={layout} key={item.id} item={item} />;
        default:
          return false;
      }
    });
  }

  return (
    <React.Fragment>
      <ListGroup.Item as="li" bsPrefix=" " key={group.id} className="nav-item pcoded-menu-caption">
        <label>{group.title}</label>
      </ListGroup.Item>
      {navItems}
    </React.Fragment>
  );
};

NavGroup.propTypes = {
  layout: PropTypes.string,
  group: PropTypes.object,
  id: PropTypes.number,
  children: PropTypes.node,
  title: PropTypes.string
};

export default NavGroup;
